module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', _vm._b({
    class: _vm.classes,
    attrs: {
      "visible": _vm.isvisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isvisible = $event
      },
      "close": _vm.close
    }
  }, 'el-dialog', _vm.$attrs, false), [_c('div', {
    staticClass: "rt-dialog-title-wrapper",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "rt-dialog-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('rt-button', {
    attrs: {
      "icon-name": "rt-base-close",
      "text": "",
      "icon-size": "24"
    },
    on: {
      "click": _vm.close
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rt-dialog-content-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-dialog-footer-wrapper",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "rt-dialog-footer-buttons"
  }, [_c('rt-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('rt-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确认")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23554858"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/dialog/rtDialog.vue
// module id = 1474
// module chunks = 124